import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import App from './App';
import { BASE_PATH } from './config';
import { store } from './store';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from './contexts/ConfigContext';
import PostHogWrapper from './posthog';
import { initSentry, SentryErrorBoundary } from './sentry';
import { startFreezeGuard } from './freezeGuard';

// style + assets
import 'assets/scss/style.scss';

initSentry();
startFreezeGuard();

// Rendered outside the theme and i18n providers, so it uses plain markup and English copy
const AppCrashFallback = () => (
    <div style={{ padding: 24, textAlign: 'center', fontFamily: 'sans-serif' }}>
        <p>Something went wrong while loading the portal. Please check your connection and try again.</p>
        <button type="button" onClick={() => window.location.reload()} style={{ padding: '8px 16px', cursor: 'pointer' }}>
            Reload
        </button>
    </div>
);

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
    <SentryErrorBoundary fallback={<AppCrashFallback />}>
        <PostHogWrapper>
            <Provider store={store}>
                <ConfigProvider>
                    <BrowserRouter basename={BASE_PATH}>
                        <App />
                    </BrowserRouter>
                </ConfigProvider>
            </Provider>
        </PostHogWrapper>
    </SentryErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
